<template>
  <b-nav :hidden="!isAdminStatus">
    <b-nav-item-dropdown
        id="my-nav-dropdown "
        text="Troubleshooting"
        toggle-class="nav-link-custom"
    >
      <template slot="button-content">
        <i class="fa mr-2 fa-tools text-orange" font-scale="1"></i>
        <span>Troubleshooting</span>
      </template>

      <b-dropdown-item to="/overwatch">
        <i class="fa fa-cogs text-yellow" font-scale="1"></i>
        Overwatch (SS7)
      </b-dropdown-item>
      
      <!-- <b-dropdown-item to="/rfreports">
        <i class="fa fa-cogs text-red" font-scale="1"></i>
        RF Reports
      </b-dropdown-item> -->

<!--      <b-dropdown-item to="/diameter">-->
<!--        <i class="fa fa-cogs text-green" font-scale="1"></i>-->
<!--        Diameter Reports-->
<!--      </b-dropdown-item>-->

    </b-nav-item-dropdown>
    
  </b-nav>
</template>
<script>
import initService from '../../../common/api-services/init-service';

export default {
  name: 'top-trouble-basic-group',
  components: {

  },
  mounted() {
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
  },
  data() {
    return {
      isAdminStatus: false,
    };
  },
}
</script>
